// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimilarListings-paddingmobile-sTYZR {
    padding: 5px 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/SimilarListings/SimilarListings.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B","sourcesContent":[".paddingmobile {\n    padding: 5px 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paddingmobile": `SimilarListings-paddingmobile-sTYZR`
};
module.exports = ___CSS_LOADER_EXPORT___;
